import { XIcon } from '@alchemiesolns/ui';
import './RecentTextChip.css';

interface RecentTextChipProps {
  text: string;
  onSelect: () => void;
  onDelete: () => void;
}

export function RecentTextChip({ text, onSelect, onDelete }: RecentTextChipProps) {
  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent chip selection when deleting
    onDelete();
  };

  return (
    <div
      className="recent-text-chip"
      onClick={onSelect}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect();
        } else if (e.key === 'Delete' || e.key === 'Backspace') {
          e.preventDefault();
          onDelete();
        }
      }}
      aria-label={`Use: ${text}`}
    >
      <span className="recent-text-chip-text">{text}</span>
      <button
        className="recent-text-chip-delete"
        onClick={handleDelete}
        aria-label={`Remove ${text} from recent items`}
        tabIndex={-1}
      >
        <XIcon />
      </button>
    </div>
  );
}
